import React, { useState, useCallback } from 'react';
import OrderDirectionsEnum from '../../Enums/OrderDirectionsEnum';
import SystemAlertSearchParams from './SystemAlertSearchParams';
import TabOfDataTable from '../../Elements/DataTable/TabOfDataTable';
import SystemAlertService from '../../Services/SystemAlertService';
import ShownPanelsEnum from '../../Enums/ShownPanelsEnum';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import ButtonRow from '../../Elements/ButtonRow';
import CrudTypesEnum from '../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditSystemAlertWindowDescription from './EditSystemAlertWindowDescription';
import SystemAlertItem from '../../Domain/SystemAlertItem';

const SystemAlertAdmin = (props) =>
{
  const [ orderBy ] = useState('Id');
  const [ orderDirection ] = useState(OrderDirectionsEnum.Desc);
  const [ searchItem, setSearchItem ] = useState(new SystemAlertSearchParams());
  const [ shownPanel, setShownPanel ] = useState(ShownPanelsEnum.None);
  const [ selectedItem, setSelectedItem ] = useState(null);

  const startSearch = useCallback((searchItem) =>
  {
    setSearchItem(searchItem);
  }, []);

  const editFunction = useCallback((id, item, itemList) =>
  {
    setSelectedItem(item);
    setShownPanel(ShownPanelsEnum.Edit);
  }, []);

  SystemAlertItem.editFunction = editFunction;

  const handleButtonRowButtonClick = (panelId) =>
  {
    panelId = panelId === shownPanel ? ShownPanelsEnum.None : panelId;
    setShownPanel(panelId);
  };

  const refresh = useCallback(() =>
  {
    setSearchItem({ ...searchItem });
  }, [ searchItem ]);

  const renderOnePanel = (panelId, content) =>
  {
    return shownPanel === panelId ? content : null;
  };

  const closeOverWindowWithRefresh = () =>
  {
    closeOverWindowWithoutRefresh();
    refresh();
  };

  const closeOverWindowWithoutRefresh = () =>
  {
    setShownPanel(ShownPanelsEnum.None);
  };

  const renderPanels = () =>
  {
    return (
      <div>
        {renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new SystemAlertItem()}
            clickOnCancel={closeOverWindowWithoutRefresh}
            clickOnSave={closeOverWindowWithRefresh}
            windowDescription={EditSystemAlertWindowDescription}
            errorCode={'LA141'}
          />
        )}
        {renderOnePanel(
          ShownPanelsEnum.Edit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={selectedItem}
            clickOnCancel={closeOverWindowWithoutRefresh}
            clickOnSave={closeOverWindowWithRefresh}
            windowDescription={EditSystemAlertWindowDescription}
            errorCode={'LA152'}
          />
        )}
        {renderOnePanel(ShownPanelsEnum.EditItem, <div className='bg-white border rounded'>Edit System Alert</div>)}
      </div>
    );
  };

  const renderButtonsAndPanels = () => (
    <>
      <ButtonRow
        colors={[ ButtonColorsEnum.Primary ]}
        tooltips={[ 'Create' ]}
        keys={[ ShownPanelsEnum.AddNewItem ]}
        icons={[ 'fa-solid fa-plus-circle' ]}
        roleKeys={[ 'systemalert_newalert_button' ]}
        value={shownPanel}
        onClick={handleButtonRowButtonClick}
      />
      {renderPanels()}
    </>
  );

  return (
    <div className='contentwrapper'>
      {renderButtonsAndPanels()}
      <TabOfDataTable
        type={SystemAlertItem}
        serviceFunction={SystemAlertService.GetListBySearching}
        convertDBItemsFunction={SystemAlertService.ConvertDBItemList}
        orderDirection={orderDirection}
        orderBy={orderBy}
        searchItem={searchItem}
        showSearchStrip={true}
        searchParamsType={SystemAlertSearchParams}
        clickOnStartSearch={startSearch}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in id, type or result...'
        errorCode='SAA120'
      />
    </div>
  );
};

export default SystemAlertAdmin;
